import { Box, CircularProgress, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { useAppSelector } from "../../app/hooks";
import { RankXPName } from "../../constants/rank";
import { toUSDFormat } from "../../utils/utils";
import CircleSingal from "../CircleSignal";

import useStyles from "./index.styles";
import clsx from "clsx";

const AssociateList = ({
  isLoadingRankList,
  page,
}: {
  isLoadingRankList: boolean;
  page: number;
}) => {
  const { classes } = useStyles();

  const { rankList, myProfile } = useAppSelector((state) => state.profile);

  return (
    <Box className={classes.associateListPanel}>
      <Box className={classes.associateListHeader}>
        <Typography># Position</Typography>
        <Typography>Status</Typography>
        <Typography>Name</Typography>
        <Typography>Rank</Typography>
        <Typography>Family</Typography>
        <Typography>Worth</Typography>
      </Box>

      {isLoadingRankList ? (
        <CircularProgress
          sx={{
            textAlign: "center",
            alignItems: "center",
            color: "white",
          }}
        />
      ) : (
        rankList.map((item, index) => (
          <Box
            className={
              myProfile.name === item.name
                ? clsx(classes.listItem, classes.selected)
                : classes.listItem
            }
            key={index}
          >
            <Box>
              <Typography>{(page - 1) * 15 + index + 1}</Typography>
            </Box>
            <Box className={classes.statusBox}>
              <CircleSingal
                width={10}
                height={10}
                color={"#38c417"}
              ></CircleSingal>{" "}
              Alive
            </Box>
            <Box className={classes.nameBox}>
              <Link to={`/profile/${item.name}`}>{item.name}</Link>
            </Box>
            <Box>{RankXPName[item.rankNumber - 1]}</Box>
            <Box>{item.family?.name}</Box>
            <Box>{toUSDFormat(item.worth, 0)}</Box>
          </Box>
        ))
      )}
    </Box>
  );
};

export default AssociateList;
